import { ProductCardSkeleton } from "@/components/commerce";
import { AppHeader } from "@/components/layout";
import { Button, Card, Chip, Skeleton } from "@/components/ui";

const SKELETON_CHIPS = ["All", "Models", "UI Kits", "Systems", "Plugins", "Free"];

export function StorePageSkeleton() {
  return (
    <>
      <AppHeader />
      <main className="mx-auto max-w-7xl p-6">
        <Card padded={false} className="mb-6 overflow-hidden">
          <Skeleton className="aspect-[16/5] w-full rounded-t-md" />
          <div className="px-4 pb-4">
            <div className="relative -mt-8 mb-3 flex items-end justify-between">
              <Skeleton className="size-16 rounded-full ring-4 ring-surface-2" />
              <div className="flex gap-2">
                <Button size="sm" disabled>Follow</Button>
                <Button size="sm" variant="secondary" iconOnly disabled aria-label="Copy store link">·</Button>
              </div>
            </div>
            <Skeleton className="h-8 w-56" />
            <Skeleton className="mt-2 h-4 w-36" />
            <Skeleton className="mt-3 h-5 w-72" />
            <Skeleton className="mt-3 h-4 w-80" />
          </div>
        </Card>
        <div className="mb-6 flex gap-2 overflow-x-auto pb-1">
          {SKELETON_CHIPS.map((label) => <Chip key={label} disabled>{label}</Chip>)}
        </div>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {Array.from({ length: 6 }, (_, index) => <ProductCardSkeleton key={index} />)}
        </div>
      </main>
    </>
  );
}
